export default {
    loginCallbackPath: "/login/callback",
};
